<template>
  <main v-if="kql.page?.content?.content" class="home">
    <BackAndForth v-for='block in JSON.parse(kql.page?.content?.content)' :key='block.id'>
      <LayoutBlock :block='block' :context='kql.page' />
    </BackAndForth>
  </main>
</template>

<script setup>
  import { useStore } from '@/KQL.js'
  const kql = useStore();
  const children = computed(()=>pageFromPath(kql.page.uid, kql?.pages)?.children);
</script>

<style scoped>
main {
    padding-top: var(--top-padding);
    /*width: var(--main-width-narrow);*/
    margin: auto;
}
</style>
